import { Types } from '../../../actions/dashboards'
import { Metrics } from '../../../constants/Dashboards'
import buildAsyncStatReducer from './asyncStatReducer'

/**
 * Wow Buttons reducer
 */
const wowButtonsReducer = buildAsyncStatReducer({
    key: Metrics.WOW_BUTTONS,
    types: {
        request: Types.DASHBOARD_WOW_BUTTONS.request,
        success: Types.DASHBOARD_WOW_BUTTONS.success,
        failure: Types.DASHBOARD_WOW_BUTTONS.failure,
    },
    transform: (state, { payload }) => {
        const data = payload instanceof Array ? payload : []
        return data.map(({ type: _type, button, count }) => ({
            type: _type,
            button,
            count,
        }))
    },
})

/**
 * Wow Dwell Time reducer
 */
const wowDwellTime = buildAsyncStatReducer({
    key: Metrics.WOW_DWELLTIME,
    types: {
        request: Types.DASHBOARD_WOW_DWELLTIME.request,
        success: Types.DASHBOARD_WOW_DWELLTIME.success,
        failure: Types.DASHBOARD_WOW_DWELLTIME.failure,
    },
    transform: (state, { payload }) => {
        const { types } = payload
        return { types }
    },
})

/**
 * Wow Dwell Timeline reducer
 */
const wowDwellTimeline = buildAsyncStatReducer({
    key: Metrics.WOW_DWELLTIMELINE,
    types: {
        request: Types.DASHBOARD_WOW_DWELLTIMELINE.request,
        success: Types.DASHBOARD_WOW_DWELLTIMELINE.success,
        failure: Types.DASHBOARD_WOW_DWELLTIMELINE.failure,
    },
    transform: (state, { payload }) =>
        Object.keys(payload || {}).reduce((carry, date) => {
            return [
                ...carry,
                {
                    moment: date,
                    time: payload[date],
                },
            ]
        }, []),
})

/**
 * L&L Dwell Timeline per product reducer
 */
const wowDwellTimelineProduct = buildAsyncStatReducer({
    key: Metrics.WOW_DWELLTIMELINE_PRODUCTS,
    types: {
        request: Types.DASHBOARD_WOW_DWELLTIMELINE_PRODUCT.request,
        success: Types.DASHBOARD_WOW_DWELLTIMELINE_PRODUCT.success,
        failure: Types.DASHBOARD_WOW_DWELLTIMELINE_PRODUCT.failure,
    },
    transform: (state, { payload }) => {
        return payload
    },
})

/**
 * Wow Dwell Time reducer
 */
const wowSessionCount = buildAsyncStatReducer({
    key: Metrics.WOW_SESSIONS_COUNT,
    types: {
        request: Types.DASHBOARD_WOW_SESSIONS_COUNT.request,
        success: Types.DASHBOARD_WOW_SESSIONS_COUNT.success,
        failure: Types.DASHBOARD_WOW_SESSIONS_COUNT.failure,
    },
    transform: (state, { payload }) => {
        const { types } = payload
        return { types }
    },
})

/**
 * Wow Top Installations reducer
 */
const wowInstallationsTopReducer = buildAsyncStatReducer({
    key: Metrics.WOW_INSTALLATIONS_TOP,
    types: {
        request: Types.DASHBOARD_WOW_INSTALLATIONS_TOP.request,
        success: Types.DASHBOARD_WOW_INSTALLATIONS_TOP.success,
        failure: Types.DASHBOARD_WOW_INSTALLATIONS_TOP.failure,
    },
    transform: (state, { payload }) => {
        const { type: installationType, count } = payload[0] || {}
        return { type: installationType, count }
    },
})

/**
 * Wow Top Media reducer
 */
const wowMediaTopReducer = buildAsyncStatReducer({
    key: Metrics.WOW_MEDIA_TOP,
    types: {
        request: Types.DASHBOARD_WOW_MEDIA_TOP.request,
        success: Types.DASHBOARD_WOW_MEDIA_TOP.success,
        failure: Types.DASHBOARD_WOW_MEDIA_TOP.failure,
    },
    transform: (state, { payload }) => {
        const { media, count } = payload[0] || {}
        return { media, count }
    },
})

/**
 * Wow Top Stores reducer
 */
const wowStoresTopReducer = buildAsyncStatReducer({
    key: Metrics.WOW_STORES_TOP,
    types: {
        request: Types.DASHBOARD_WOW_STORES_TOP.request,
        success: Types.DASHBOARD_WOW_STORES_TOP.success,
        failure: Types.DASHBOARD_WOW_STORES_TOP.failure,
    },
    transform: (state, { payload }) => {
        return payload.map(({ store_code: storeCode, count }) => ({
            storeCode,
            count,
        }))
    },
})

const wowReducers = [
    wowButtonsReducer,
    wowDwellTime,
    wowDwellTimeline,
    wowDwellTimelineProduct,
    wowSessionCount,
    wowInstallationsTopReducer,
    wowMediaTopReducer,
    wowStoresTopReducer,
]

export default wowReducers
